export default "__VITE_ASSET__CfDMEEhN__"